import { render } from "./Onboarding.vue?vue&type=template&id=6ea52ceb&scoped=true&ts=true"
import script from "./Onboarding.vue?vue&type=script&lang=ts"
export * from "./Onboarding.vue?vue&type=script&lang=ts"

import "./Onboarding.vue?vue&type=style&index=0&id=6ea52ceb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ea52ceb"]])

export default __exports__